<template>
  <el-checkbox-group :min="1" @change="change" v-model="y">
    <div v-for="(obj,index) in numberfields" :key="index" style="margin-right:1rem;display:inline-block">
      <el-checkbox :label="obj.name">{{obj.title}}</el-checkbox>
      <div
      v-show="yvalues.indexOf(obj.name)>-1"
        v-bind:style="{'background-color':'#'+colors[yvalues.indexOf(obj.name)],width:'100%',height:'0.5rem'}"
      ></div>
    </div>
  </el-checkbox-group>
</template>

<script>
import palette from "google-palette";
export default {
  props:["yvalues","numberfields"],

 data(){
   return{
     y:this.yvalues
   }
 },
 watch:{
   yvalues(newval){this.y=newval}

 },
  computed: {

    colors() {
      return palette("mpn65", this.yvalues.length);
    },

  },

  methods:{
    change(val){this.$emit("ychange",val)}

  }


};
</script>




// WEBPACK FOOTER //
// src/components/presentation/chart/yvalues.vue